import * as React from 'react';

import { RouteComponentProps, StaticContext } from 'react-router';
import ELearningContainer from '../containers/ELearning';

/**
 * パスパラメータ
 */
export interface IELearningPathParams {
	career_id: string;
	class_id: string;
}

/**
 * push時に渡すパラメータ
 */
export interface IELearningPushState {
	caller: string;
	outOfPeriodFlg: boolean;
	showTree?: boolean;
}

/**
 * eラーニング受講画面
 * @param props
 */
const ELearning: React.FC<
	RouteComponentProps<
		IELearningPathParams,
		StaticContext,
		IELearningPushState
	>
> = props => (
	<ELearningContainer
		careerID={props.match.params.career_id}
		classID={props.match.params.class_id}
		outOfPeriodFlg={props.location.state.outOfPeriodFlg}
		preview={false}
		state={props.location.state}
	/>
);

export default ELearning;



// WEBPACK FOOTER //
// ./src/pages/ELearning.tsx